/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Preset } from '../models/Preset';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class RenderingService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Render NFT (CDN URL)
     * Returns CDN URL for NFT media
     * @returns Preset OK
     * @throws ApiError
     */
    public renderNft({
        address = '0xBC4CA0EdA7647A8aB7C2061c2E118A18a936f13D',
        network = 'ethereum-mainnet',
        preset = 'small',
        tokenId = '1',
    }: {
        /** Collection Address **/
        address?: string,
        /** Network ID **/
        network?: 'arbitrum-mainnet' | 'avalanche-mainnet' | 'bsc-mainnet' | 'celo-mainnet' | 'ethereum-goerli' | 'ethereum-mainnet' | 'ethereum-rinkeby' | 'ethereum-ropsten' | 'fantom-mainnet' | 'harmony-mainnet' | 'optimism-mainnet' | 'polygon-mainnet' | 'solana-mainnet',
        /** Preset Type **/
        preset?: 'small' | 'medium' | 'original',
        /** Token ID **/
        tokenId?: string,
    }): CancelablePromise<Preset> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/{network}/{address}/{tokenID}/{preset}',
            path: {
                'address': address,
                'network': network,
                'preset': preset,
                'tokenID': tokenId,
            },
            errors: {
                400: `Validation Error`,
                422: `network ID is invalid or asset does not have associated metadata`,
                504: `Failed to fetch data from the external site before timeout`,
            },
        });
    }

    /**
     * Render NFT (Direct Media)
     * Returns NFT media directly
     * @returns any OK
     * @throws ApiError
     */
    public renderNftMedia({
        address = '0xBC4CA0EdA7647A8aB7C2061c2E118A18a936f13D',
        network = 'ethereum-mainnet',
        preset = 'small',
        tokenId = '1',
    }: {
        /** Collection Address **/
        address?: string,
        /** Network ID **/
        network?: 'arbitrum-mainnet' | 'avalanche-mainnet' | 'bsc-mainnet' | 'celo-mainnet' | 'ethereum-goerli' | 'ethereum-mainnet' | 'ethereum-rinkeby' | 'ethereum-ropsten' | 'fantom-mainnet' | 'harmony-mainnet' | 'optimism-mainnet' | 'polygon-mainnet' | 'solana-mainnet',
        /** Preset Type **/
        preset?: 'small' | 'medium',
        /** Token ID **/
        tokenId?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/{network}/{address}/{tokenID}/{preset}/media',
            path: {
                'address': address,
                'network': network,
                'preset': preset,
                'tokenID': tokenId,
            },
            errors: {
                400: `Validation Error`,
                422: `network ID is invalid or asset does not have associated metadata`,
                504: `Failed to fetch data from the external site before timeout`,
            },
        });
    }

}